<template>
    <div>
        <header class="panel__header">
            <h2 class="panel__title">Change Email</h2>
        </header>
        <div v-if="successful">
            <p>We've sent you an email to confirm your new address: <strong>{{ form.email }}</strong>.</p>
            <p>Make sure you click the link in it! We will continue to use your old address <strong>({{ user.email }})</strong> until you confirm the change.</p>
        </div>
        <form v-else @submit.prevent="save" action="#" class="form form--grid">
            <p>Your email address is <strong>{{ user.email }}</strong></p>
            <div class="form__group">
                <label for="password" class="form__label">Current Password</label>
                <input v-model="form.password" id="password" type="password" class="form__input" :class="{ 'form__input--error' : form.errors.has('password') }">
                <span v-if="form.errors.has('password')" class="form__help form__help--error">{{ form.errors.get('password') }}</span>
            </div>
            <div class="form__group">
                <label for="email" class="form__label">New Email Address</label>
                <input v-model="form.email" id="email" type="text" class="lc-first form__input" :class="{ 'form__input--error' : form.errors.has('email') }">
                <span v-if="form.errors.has('email')" class="form__help form__help--error">{{ form.errors.get('email') }}</span>
            </div>
            <footer class="form__footer">
                <button type="submit" class="lc-save button button--primary" :disabled="form.busy">Save</button>
            </footer>
        </form>
    </div>
</template>

<script>
/* global EventBus */
import { mapState } from 'vuex'
import Form from '../../helpers/Form'

export default {
    data () {
        return {
            successful: false,
            form: new Form({
                email: '',
                password: ''
            })
        }
    },

    methods: {
        save () {
            this.$store.dispatch('users/sendEmailChangeRequest', this.form).then(() => {
                this.successful = true
                EventBus.$emit('newSnackbar', `Email change request was sent`)
            })
        }
    },

    computed: {
        ...mapState('users', {
            user: 'current'
        })
    }
}
</script>
